(() => {
  const selectors = {
    tabName: ".tab-name",
    tab: ".tab-container",
  };

  $(document).on("click", selectors.tabName, function () {
    $(selectors.tabName).removeClass("active");
    $(this).addClass("active");

    $(selectors.tab).removeClass("active");
    $(`${selectors.tab}[data-tab="${$(this).attr("data-tab")}"]`).addClass(
      "active"
    );
  });
})();
